import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { id: "container" }
const _hoisted_3 = { id: "main-content-port" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = {
  key: 0,
  class: "kakugo w100",
  style: {"height":"160px","top":"0","z-index":"10"}
}
const _hoisted_6 = {
  class: "ofh w70 fl",
  style: {"margin-top":"25px"}
}
const _hoisted_7 = {
  class: "fs24 ls1 fl fw600",
  style: {"margin-left":"80px","margin-top":"24px"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "fl" }, "進捗管理", -1)
const _hoisted_9 = {
  key: 1,
  class: "fl",
  style: {"margin-left":"45px"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "fl fs14 fw400",
  style: {"margin-top":"7px"}
}, "絞り込み: ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = {
  class: /*#__PURE__*/_normalizeClass(`fr circle_button fw600 centered fs12 blueAround`),
  style: {"width":"220px","padding":"4px 10px","margin-top":"30px","border":"0"}
}
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", {
  class: "fw600 fl",
  style: {"margin-bottom":"0"}
}, " レポート画面に切り替え", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = {
  key: 1,
  class: ""
}
const _hoisted_17 = {
  key: 2,
  class: "w100 roomTableContentWrapper",
  style: {"min-width":"1000px"}
}
const _hoisted_18 = { class: "w100 roomTableContent" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("tr", {
  class: "w100",
  style: {"border-bottom":"1px solid #e9ecf1","border-top":"1px solid #e9ecf1"}
}, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "4",
    class: "fs12 fw600 pad5",
    style: {"height":"20px"}
  }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("div", {
        class: "fl centered",
        style: {"margin-left":"640px","margin-top":"7px"}
      }, "送信済み"),
      /*#__PURE__*/_createElementVNode("div", {
        class: "fl centered",
        style: {"margin-left":"72px"}
      }, [
        /*#__PURE__*/_createTextVNode(" メール "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("開封済み ")
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        class: "fl centered",
        style: {"margin-left":"76px","margin-top":"7px"}
      }, "入室済み"),
      /*#__PURE__*/_createElementVNode("div", {
        class: "fl centered",
        style: {"margin-left":"60px"}
      }, [
        /*#__PURE__*/_createTextVNode(" 調整カレンダー "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("共有済み ")
      ])
    ])
  ])
], -1)
const _hoisted_20 = { key: 3 }
const _hoisted_21 = {
  class: "centered",
  style: {"margin-top":"100px"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "アクティブな調整ページがありません。", -1)
const _hoisted_23 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_ChukaiSidebarMenu = _resolveComponent("ChukaiSidebarMenu")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RoomsLoader = _resolveComponent("RoomsLoader")!
  const _component_ProgressCell = _resolveComponent("ProgressCell")!
  const _component_RoomHistoryDetailModal = _resolveComponent("RoomHistoryDetailModal")!
  const _component_RemindModal = _resolveComponent("RemindModal")!
  const _component_AnsweredFormModal = _resolveComponent("AnsweredFormModal")!
  const _directive_scroll = _resolveDirective("scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_ChukaiSidebarMenu, { currentPage: `reports` }),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("section", _hoisted_4, [
          (!_ctx.isSP)
            ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h4", _hoisted_7, [
                    _hoisted_8,
                    (_ctx.userFilter)
                      ? (_openBlock(), _createBlock(_component_SelectTag, {
                          key: 0,
                          name: "members_names",
                          id: "select_members_names",
                          class: "fl fs14 roundForm",
                          style: {"margin-left":"20px","min-width":"140px","height":"50px","margin-top":"-10px"},
                          options: [`自分`, `全体`],
                          defaultOption: _ctx.userFilter == `self` ? `自分` : `全体`,
                          onSelectValue: _ctx.filterUser,
                          isDisabled: false
                        }, null, 8, ["defaultOption", "onSelectValue"]))
                      : _createCommentVNode("", true),
                    (_ctx.filterNameArray)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _hoisted_10,
                          _createVNode(_component_SelectTag, {
                            name: "filter_names",
                            id: "select_filter_name",
                            class: "fl fs14 roundForm",
                            style: {"margin-left":"20px","min-width":"200px","height":"50px","margin-top":"-10px"},
                            options: _ctx.filterNameArray,
                            defaultOption: _ctx.filterDic[_ctx.selectedFilterName],
                            onSelectValue: _ctx.selectFilterName,
                            isDisabled: false
                          }, null, 8, ["options", "defaultOption", "onSelectValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_11
                ]),
                (_ctx.UserPermissionsOption.permitDisplay(_ctx.rm.userInfo, `reports`, `reports`))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/reports"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("label", _hoisted_12, [
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/graph.png`),
                            width: "17",
                            height: "16",
                            style: {"margin-top":"2px"},
                            class: "fl"
                          }, null, 8, _hoisted_13),
                          _hoisted_14
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _hoisted_15
              ]))
            : _createCommentVNode("", true),
          (!_ctx.currentRooms)
            ? (_openBlock(), _createElementBlock("section", _hoisted_16, [
                _createVNode(_component_RoomsLoader)
              ]))
            : (!_ctx.Util.isBlank(_ctx.currentRooms))
              ? (_openBlock(), _createElementBlock("section", _hoisted_17, [
                  _withDirectives((_openBlock(), _createElementBlock("table", _hoisted_18, [
                    _hoisted_19,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentRooms, (room, roomindex) => {
                      return (_openBlock(), _createBlock(_component_ProgressCell, {
                        room: room,
                        key: `${room.id}-${roomindex}`,
                        onShowHistory: _ctx.showHistory,
                        onClickRemind: _ctx.clickRemind,
                        onClickFormMember: _ctx.clickFormMember,
                        onGoSummaryFromParent: _ctx.goSummaryFromParent
                      }, null, 8, ["room", "onShowHistory", "onClickRemind", "onClickFormMember", "onGoSummaryFromParent"]))
                    }), 128))
                  ])), [
                    [_directive_scroll, _ctx.scroll]
                  ])
                ]))
              : (_openBlock(), _createElementBlock("section", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                      width: "40",
                      height: "40"
                    }, null, 8, _hoisted_23)
                  ])
                ]))
        ])
      ]),
      _createVNode(_component_RoomHistoryDetailModal, { room: _ctx.historyRoom }, null, 8, ["room"]),
      _createVNode(_component_RemindModal, {
        selectedUsers: _ctx.selectedUsers,
        selectedRooms: _ctx.selectedRooms,
        parg: _ctx.selectedParg,
        from: `rooms`,
        selectedLpId: _ctx.selectedLpId
      }, null, 8, ["selectedUsers", "selectedRooms", "parg", "selectedLpId"]),
      _createVNode(_component_AnsweredFormModal, {
        member: _ctx.selectedMember,
        room: _ctx.selectedRoom,
        onUpdateMember: _ctx.updateMember
      }, null, 8, ["member", "room", "onUpdateMember"])
    ])
  ]))
}